export default {
    namespaced: true,
    state: {
        plan_trial_remain_flag: false,
        plan_trial_remain_count: 0
    },
    mutations: {
        // プラントライアル残日数の情報をセット
        setPlanTrialRemainInformation(state, plan_trial_remain_information) {
            state.plan_trial_remain_flag = plan_trial_remain_information.plan_trial_remain_flag ? plan_trial_remain_information.plan_trial_remain_flag : false;
            state.plan_trial_remain_count = plan_trial_remain_information.plan_trial_remain_count ? plan_trial_remain_information.plan_trial_remain_count : 0;
        }
    },
    actions: {},
    getters: {
        // プラントライアル残日数の表示フラグを取得
        getPlanTrialRemainFlag(state) {
            return state.plan_trial_remain_flag;
        },
        // ラントライアル残日数を取得
        getPlanTrialRemainCount(state) {
            return state.plan_trial_remain_count;
        }
    }
}
